<div class="financing-activities-table">
    <div class="table-title">
        <ham-inline-table-cell-edit
            [value]="financingActivitiesTitle"
            (save)="onSaveTitle($event)"
        ></ham-inline-table-cell-edit>
    </div>
    <div class="form-container" *ngIf="form">
        <form [formGroup]="form">
            <ng-container formArrayName="dataSource" *ngIf="!isVirtualized">
                <table>
                    <thead>
                        <tr>
                            <th class="aumOverflowEdit" style="width: 55.6%">
                                <span>{{ currency }}</span>
                            </th>

                            <th class="aumHighlight" style="width: 22%">
                                <span>{{ currentYearDate | dateLocale }}</span>
                            </th>

                            <th style="width: 18%">
                                <span>{{ previousYearDate | dateLocale }}</span>
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody cdkDropList [cdkDropListData]="tableEntries" (cdkDropListDropped)="onListDrop($event)">
                        <tr
                            *ngFor="let element of dataSource.controls; let rowIndex = index; trackBy: trackByIndex"
                            [formGroup]="element"
                            cdkDrag
                            (cdkDragMoved)="onRowDragMoved($event)"
                            (cdkDragEnded)="onRowDragEnded()"
                        >
                            <td class="flex-wrapper">
                                <span class="ham-icon ham-icon-drag" cdkDragHandle>
                                    <i class="drag-icon"></i>
                                </span>
                                <div class="input-badge-wrapper">
                                    <input type="text" formControlName="name" class="text-input" hamInput />
                                    <div
                                        *ngIf="!element['controls']?.['isCustom']?.value; else customFli"
                                        class="ham-badge"
                                        hamBadge
                                        color="indigo"
                                        size="small"
                                        [hasCancelIcon]="false"
                                    >
                                        {{ 'aumico_annual_report_financing_activities' | i18next }}
                                    </div>
                                </div>

                                <ng-template #customFli>
                                    <div class="ham-badge" hamBadge color="yellow" size="small" [hasCancelIcon]="false">
                                        {{ 'aumico_annual_report_cash_flow_manual' | i18next }}
                                    </div>
                                </ng-template>
                            </td>
                            <!-- Current Year Column -->
                            <td class="aumHighlight">
                                <aumico-overridable-value-input
                                    formControlName="currentValue"
                                    [systemValue]="element['controls']?.['systemCurrentValue']?.value"
                                ></aumico-overridable-value-input>
                            </td>

                            <td>
                                <aumico-overridable-value-input
                                    formControlName="previousValue"
                                    [systemValue]="element['controls']?.['systemPreviousValue']?.value"
                                ></aumico-overridable-value-input>
                            </td>

                            <td>
                                <span type="button" class="ham-icon" (click)="removeAt(rowIndex)"
                                    ><i class="grey-remove-icon"></i
                                ></span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="add-new-item-cell">
                                <span class="total-text">
                                    {{
                                        'aumico_annual_report_cash_flow_total_financing_activities'
                                            | i18nextWithLocale : reportLocale
                                    }}
                                </span>
                            </td>
                            <!-- Current Year Total -->
                            <td class="aumHighlight">
                                <span class="margin-top-70">
                                    {{ currentTotal | finNumber : numberFormat }}
                                </span>
                            </td>
                            <!-- Previous Year Total -->
                            <td>
                                <span class="margin-top-70">
                                    {{ previousTotal | finNumber : numberFormat }}
                                </span>
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </ng-container>

            <!-- Virtualized rendering for very large datasets (REV-21417): only visible rows are
                 created, so thousands of entries no longer freeze / OOM the tab. Drag-reorder is
                 unavailable in this mode; normal-sized tables keep the full table above with drag. -->
            <div *ngIf="isVirtualized" class="cfs-virtual">
                <div class="cfs-vrow cfs-vheader">
                    <div class="cfs-vcell name">{{ currency }}</div>
                    <div class="cfs-vcell num aumHighlight">{{ currentYearDate | dateLocale }}</div>
                    <div class="cfs-vcell num">{{ previousYearDate | dateLocale }}</div>
                    <div class="cfs-vcell action"></div>
                </div>
                <cdk-virtual-scroll-viewport [itemSize]="VIRTUAL_ROW_HEIGHT" class="cfs-viewport">
                    <div
                        class="cfs-vrow"
                        *cdkVirtualFor="let element of dataSource.controls; let i = index; trackBy: trackByIndex"
                        [formGroup]="element"
                    >
                        <div class="cfs-vcell name">
                            <div class="input-badge-wrapper">
                                <input type="text" formControlName="name" class="text-input" hamInput />
                                <div
                                    *ngIf="!element['controls']?.['isCustom']?.value"
                                    class="ham-badge"
                                    hamBadge
                                    color="indigo"
                                    size="small"
                                    [hasCancelIcon]="false"
                                >
                                    {{ 'aumico_annual_report_financing_activities' | i18next }}
                                </div>
                                <div
                                    *ngIf="element['controls']?.['isCustom']?.value"
                                    class="ham-badge"
                                    hamBadge
                                    color="yellow"
                                    size="small"
                                    [hasCancelIcon]="false"
                                >
                                    {{ 'aumico_annual_report_cash_flow_manual' | i18next }}
                                </div>
                            </div>
                        </div>
                        <div class="cfs-vcell num aumHighlight">
                            <aumico-overridable-value-input
                                formControlName="currentValue"
                                [systemValue]="element['controls']?.['systemCurrentValue']?.value"
                            ></aumico-overridable-value-input>
                        </div>
                        <div class="cfs-vcell num">
                            <aumico-overridable-value-input
                                formControlName="previousValue"
                                [systemValue]="element['controls']?.['systemPreviousValue']?.value"
                            ></aumico-overridable-value-input>
                        </div>
                        <div class="cfs-vcell action">
                            <span type="button" class="ham-icon" (click)="removeAt(i)"><i class="grey-remove-icon"></i></span>
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
                <div class="cfs-vrow cfs-vfooter">
                    <div class="cfs-vcell name total-text">
                        {{ 'aumico_annual_report_cash_flow_total_financing_activities' | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="cfs-vcell num aumHighlight">{{ currentTotal | finNumber : numberFormat }}</div>
                    <div class="cfs-vcell num">{{ previousTotal | finNumber : numberFormat }}</div>
                    <div class="cfs-vcell action"></div>
                </div>
            </div>
        </form>
        <div class="add-row">
            <ham-button [outline]="true" size="xs" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="addRow()">
                {{ 'aumico_annual_report_cash_flow_add_new_item' | i18next }}
            </ham-button>
        </div>
    </div>
</div>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteModal"
    (cancel)="onCancelDelete()"
    (action)="onDeleteFliRow()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_annual_report_delete_item_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
